import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { EAppAccountType } from 'v2/modules/system-setting/constants/app-integration-account.enum';

import { PAUSE_BUFFER_QUANTITY } from '../../configs/channel-mapping.config';
import { IChannelProduct } from '../../interfaces';

interface IChannelProductMappingActionCellRendererParams
  extends ICellRendererParams {
  createSku :(data :IChannelProduct) => void;
  addVariantSku :(data :IChannelProduct) => void;
  addAlternateSku :(data :IChannelProduct) => void;
  pushSingleProduct :(data :IChannelProduct) => void;
  toggleOverBuffer :(data :IChannelProduct, toggled :boolean) => void;
}

@Component({
  selector: 'lum-channel-product-mapping-action-cell-renderer-v2',
  templateUrl: './channel-product-mapping-action-cell-renderer-v2.component.html',
  styleUrls: ['./channel-product-mapping-action-cell-renderer-v2.component.scss'],
})
export class ChannelProductMappingActionCellRendererV2Component
  implements ICellRendererAngularComp
{
  params :IChannelProductMappingActionCellRendererParams;
  matTooltip :string = 'Add as Alternate Sku';
  bigNumberBuffer :number = PAUSE_BUFFER_QUANTITY;
  appAccountType = EAppAccountType;

  agInit(params :IChannelProductMappingActionCellRendererParams) :void {
    this.params = params;
    this.checkForExistingAlternateSku();
  }

  refresh(params :IChannelProductMappingActionCellRendererParams) :boolean {
    return false;
  }

  onCreateSku() :void {
    this.params.createSku(this.params.data);
  }

  onCreateVariantSku() :void {
    this.params.addVariantSku(this.params.data);
  }

  onPushProduct() :void {
    this.params.pushSingleProduct(this.params.data);
  }

  onAddAlternateSku() :void {
    this.params.addAlternateSku(this.params.data);
  }

  onToggleOverBuffer(toggled :boolean = false) :void {
    this.params.toggleOverBuffer(this.params.data, toggled);
  }

  get bufferQuantity() :number {
    if (this.params.data.productOverride) {
      return this.params.data.productOverride.bufferQuantity;
    }

    return this.params.data.bufferQuantity;
  }

  get isOverBuffer() :boolean {
    return this.bufferQuantity >= PAUSE_BUFFER_QUANTITY;
  }

  get hasLumSku() :boolean {
    const productOverride = this.params.data?.productOverride ?? null;

    return productOverride?.lumSkuId > 0 || this.params.data?.lumSkuId > 0;
  }

  private checkForExistingAlternateSku() :void {
    if (this.params.data.existingAlternateSku) {
      this.matTooltip = 'Already added as Alternate Sku';
    }
  }
}
